import {deepOrange, grey} from "@mui/material/colors";
import {Grid, IconButton} from "@mui/material";
import {PropsWithChildren} from "react";
import {css} from "@emotion/css";
import {Address, RefreshRouteItems} from "./RouteItems";
import {KeyboardArrowDown, KeyboardArrowUp} from "@mui/icons-material";
import {api} from "../../../api/API";
import {useSnackbar} from "../../../misc/Snackbar";
import {RouteStop} from "../../../api/Logistics";
import {AddressPopup} from "./AddressPopup";
import {ContactPopup} from "./ContactPopup";
import LocalShipping from "@mui/icons-material/LocalShipping";
import {NotesPopup} from "./NotesPopup";

export function RouteItemRow(props: PropsWithChildren<{
    icon: any;
    title: any;
    driverAt?: boolean;
    value: RouteStop;
    next: RouteStop | null;
    prev: RouteStop | null;
    address: Address | null;
    disabled?: boolean;
}>) {
    const snack = useSnackbar();
    const update = async (value: RouteStop) => {
        try {
            snack.loading();
            await api.logistics.upsertStop(value);

            RefreshRouteItems.emit({
                updatedByUs: true,
            });

            snack.success("Updated!")
        } catch (e: any) {
            snack.error(e.toString());
        }
    }

    return (
        <div style={{fontSize: "0.8rem"}}>
            <div style={{paddingLeft: 12, backgroundColor: grey["100"], paddingBottom: 4, paddingTop: 4}}>
                <Grid container spacing={1} alignItems="center">
                    <Grid item>
                        <div style={{fontSize: "1.1rem", height: "1em", overflow: "hidden"}}>
                            {props.icon}
                        </div>
                    </Grid>
                    <Grid item xs>
                        <div style={{paddingBottom: 4, paddingTop: 4, display: "flex"}}>
                            {props.title}
                            {props.driverAt && <div style={{fontSize: "1.1rem", paddingLeft: 4, color: deepOrange["800"], height: "1em", overflow: "hidden"}}>
                                <LocalShipping fontSize="inherit" color="inherit" />
                            </div>}
                            <AddressPopup
                                value={props.address}
                                stop={props.value}
                                onUpdate={async (value) => {
                                    await api.logistics.upsertStop(value);

                                    RefreshRouteItems.emit({
                                        updatedByUs: true,
                                    });
                                }}
                            />
                            {props.value.contacts.length > 0 && <ContactPopup
                                value={props.value.contacts}
                                company={props.value.manufacturer || props.value.customCompanyForContacts || undefined}
                                project={props.value.project}
                                stop={props.value}
                                onUpdate={async (value) => {
                                    await api.logistics.upsertStop(value);

                                    RefreshRouteItems.emit({
                                        updatedByUs: true,
                                    });
                                }}
                            />}
                            <NotesPopup value={props.value.noteToDriver} onChange={(value) => {
                                return update(Object.assign({}, props.value, {
                                    noteToDriver: value,
                                }));
                            }} />
                        </div>
                    </Grid>
                    <Grid item>
                        {props.prev && <IconButton size="small" disabled={props.disabled} onClick={() => {
                            if(!props.prev) return;
                            update(Object.assign({}, props.value, {
                                sortOrder: props.prev.sortOrder,
                            }));
                        }}>
                            <KeyboardArrowUp />
                        </IconButton>}
                        {props.next && <IconButton size="small" disabled={props.disabled} onClick={async () => {
                            if(!props.next) return;
                            update(Object.assign({}, props.value, {
                                sortOrder: props.next.sortOrder,
                            }));
                        }}>
                            <KeyboardArrowDown />
                        </IconButton>}
                    </Grid>
                </Grid>
            </div>
            <div style={{paddingLeft: 37}} className={rowItemsClass}>
                {props.children}
            </div>
        </div>
    )
}

const rowItemsClass = css({
    "& table": {
        width: "100%",
        "& td:nth-child(1)": {
            width: 200,
        },
        "& td:nth-child(2)": {
            width: 80,
            textAlign: "right",
        },
        "& td:nth-child(4)": {
            textAlign: "right",

            "& .actions": {
                display: "inline-flex",
                height: 16,
                alignItems: "center",
            }
        },
    }
})